<template>
    <a class="flex flex-col group" :href="entry.url">
        <div class="aspect-w-4 aspect-h-3 overflow-hidden">
            <img
                v-if="featuredImage"
                class="block absolute left-0 top-0 w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700 ease-in-out"
                :src="featuredImage.url"
                :srcset="featuredImage.srcset"
                :alt="entry.title"
                loading="lazy"
            />
        </div>

        <div class="my-4 flex-1">
            <p class="text-sm text-gray-600 font-medium">{{ postDate }}</p>

            <h3 class="h5 mt-4">{{ entry.title }}</h3>
        </div>

        <div>
            <span class="btn btn--primary inline-flex items-center">
                <span>Full story</span>
                <arrow-right class="w-3 h-auto ml-2" />
            </span>
        </div>
    </a>
</template>

<script setup>
    import { computed } from 'vue';
    import ArrowRight from '@/img/icons/arrow-right.svg?component';
    import dayjs from 'dayjs';

    const props = defineProps({
        entry: {
            type: Object,
            required: true,
        },
    });

    const featuredImage = computed(() => props.entry.newsFeaturedImage[0] ?? null);

    const postDate = computed(() => {
        const date = dayjs(props.entry.postDate);
        return date.format('DD.MM.YYYY');
    });
</script>
